import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { MethodSection } from '../components/sections/MethodSection';
import { AudienceSection } from '../components/sections/AudienceSection';
import { ProofAndFAQ } from '../components/sections/ProofAndFAQ';
import { OfferBlock } from '../components/sections/OfferBlock';
import { Footer } from '../components/sections/Footer';
export function SalesPage() {
  return <div className="min-h-screen w-full bg-[#FFF8F0]" data-id="element-176">
      <HeroSection data-id="element-177" />
      <ProblemSection data-id="element-178" />
      <MethodSection data-id="element-179" />
      <AudienceSection data-id="element-180" />
      <ProofAndFAQ data-id="element-181" />
      <OfferBlock data-id="element-182" />
      <Footer data-id="element-183" />
    </div>;
}